import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import {
  getSettingsListSuccess,
  toggleSettingLoading,
} from 'store/setting/actions';
import { startWithEndWith, NO_OP } from 'middleware/utils';
import {
  GET_SETTINGS_LIST,
  UPDATE_SETTINGS_LIST,
  getSettingsList,
} from './actions';

const getSettingsListEpic = (action$, state$, { settingsRequest }) => action$.pipe(
  ofType(GET_SETTINGS_LIST),
  mergeMap(() => settingsRequest.getSettings$().pipe(
    mergeMap((response) => {
      const { data } = response;
      return of(getSettingsListSuccess(data));
    }),
    catchError(() => of(NO_OP)),
    startWithEndWith(toggleSettingLoading(true), toggleSettingLoading(false)),
  )),
  catchError(() => of(NO_OP)),
);

const updateSettingsListEpic = (action$, state$, { settingsRequest }) => action$.pipe(
  ofType(UPDATE_SETTINGS_LIST),
  mergeMap((params) => {
    const { payload } = params;
    const { settings } = payload;
    return settingsRequest.updateSettings$(settings).pipe(
      mergeMap(() => of(getSettingsList())),
      catchError(() => of(NO_OP)),
    );
  }),
  catchError(() => of(NO_OP)),
);

export default combineEpics(
  getSettingsListEpic,
  updateSettingsListEpic,
);
